import type { InjectionKey, Ref } from "vue";

// OIDC
export const OIDC_CALLBACK_URI = "/oidc_callback";
export const OIDC_SCOPE = "openid";
export const OIDC_RESPONSE_TYPE = "code";

// ERROR URI
export const ERROR_PAGE_URI = "/error";

// ERROR CODE
// Cloned and updated from ANM project
export const ERROR_CODE = {
  // Default common errors
  DEFAULT: 0,
  // Authentication common error
  AUTHENTICATION_SERVER: 6,
};

// API Status Code
export const API_STATUS = {
  IDLE: "IDLE",
  RUNNING: "RUNNING",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
};

// API Status Code
export const ROUTE = {
  CreatElementView: "creatElementView",
  CreateElementOverviewView: "createElementOverviewView",
  ProcessOverview: "processOverview",
  EditProcess: "EditProcess",
  NewProcess: "NewProcess",
  NewMainActivity: "NewMainActivity",
  EditMainActivity: "EditMainActivity",
  NewSubActivity: "NewSubActivity",
  EditSubActivity: "EditSubActivity",
  KontoplanViewDetail: "kontoplanViewDetail",
  FinanslovsstrukturViewDetail: "finanslovsstrukturViewDetail",
  RegnskabsstrukturViewDetail: "regnskabsstrukturViewDetail",
  Regnskabsstruktur: "regnskabsstruktur",
  Finanslovsstruktur: "finanslovsstruktur",
  Kontoplan: "kontoplan",
  PeriodsView: "perioder",
  AktiviteterView: "aktiviteter",
  LoengrupperView: "loengrupper",
  LoenfaellesskabDetail: "loenfaellesskabDetail",
  LoengruppeDetail: "loengruppeDetail",
  CreateLoenfaellesskabView: "createLoenfaellesskabView",
  CreateLoengruppeView: "createLoengruppeView",
  Kontobroer: "kontobroer",
};

// API Status Code
export const USERROLE = {
  SADARegnskabsstruktur: "SADARegnskabsstruktur",
  SADARegnskabsstrukturCentral: "SADARegnskabsstrukturCentral",
  SADACentralAdministrator: "SADACentralAdministrator",
  SADAKontobroAdministrator: "SADAKontobroAdministrator",
};

// Provide, Inject Symbols
export const PROVIDE_INJECT_SYMBOLS = {
  PAGE_CONTENT_CONTAINER_ID: Symbol("pageContentContainerId") as InjectionKey<Ref<string>>,
};
